module.exports = __webpack_public_path__ + "media/honey-icons/icon-deliver-xl-db6b951f.svg";